import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()
const prefix = '/v2/intersolve'

// Schema definitions
const VatRegulationSchema = z
  .object({
    code: z.string().optional(),
  })
  .passthrough()

const SecurityCodeInfoSchema = z
  .object({
    required: z.boolean().optional(),
  })
  .passthrough()

const AllowedMethodSchema = z
  .object({
    code: z.string().optional(),
    securityCodeInfo: SecurityCodeInfoSchema.optional(),
  })
  .passthrough()

const IdentitySchema = z
  .object({
    type: z.string().optional(),
    subType: z.string().optional(),
    code: z.string().optional(),
  })
  .passthrough()

export const AssetSchema = z
  .object({
    identity: IdentitySchema.optional(),
    name: z.string().optional(),
    status: z.string().optional(),
    minorUnit: z.number().optional(),
    tags: z.array(z.string()).optional(),
    conversions: z.array(z.string()).optional(),
    images: z.array(z.string()).optional(),
    vatRegulation: VatRegulationSchema.optional(),
    currency: z.string().optional(),
    rank: z.number().optional(),
    allowedMethods: z.array(AllowedMethodSchema).optional(),
  })
  .passthrough()

const IntersolveShopSchema = z
  .object({
    id: z.string().optional(),
    name: z.string().optional(),
    customerId: z.string().optional(),
    type: z.string().optional(),
  })
  .passthrough()

// Contract
export const intersolve = c.router({
  getShops: {
    method: 'GET',
    path: `${prefix}/shops`,
    responses: {
      200: z.array(IntersolveShopSchema),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get Intersolve shops',
  },
})
